import {
  ExperienceBookableItem,
  ExperienceId,
  ExperiencesPriceBreakdown,
  ExperiencesShopOptionRequest,
  ExperiencesShopResponse,
  ExperiencesShopReviewsRequest,
  ExperiencesShopReviewsResponse,
  IPassengerCounts,
  TrackingProperties,
} from "redmond";
import * as H from "history";
import * as actionTypes from "./constants";

export interface IFetchExperiencesShop {
  type: actionTypes.FETCH_EXPERIENCES_SHOP;
  history: H.History;
}

export const fetchExperiencesShop = (args: {
  history: H.History;
}): IFetchExperiencesShop => ({
  type: actionTypes.FETCH_EXPERIENCES_SHOP,
  ...args,
});

export interface ISetExperiencesShopDetails {
  type: actionTypes.SET_EXPERIENCES_SHOP_DETAILS;
  response: ExperiencesShopResponse;
}

export const setExperiencesShopDetails = (args: {
  response: ExperiencesShopResponse;
}): ISetExperiencesShopDetails => ({
  type: actionTypes.SET_EXPERIENCES_SHOP_DETAILS,
  ...args,
});

export interface ISetExperiencesShopDetailsCallStateFailed {
  type: actionTypes.SET_EXPERIENCES_SHOP_CALL_FAILED;
}

export const setExperiencesShopDetailsCallStateFailed =
  (): ISetExperiencesShopDetailsCallStateFailed => ({
    type: actionTypes.SET_EXPERIENCES_SHOP_CALL_FAILED,
  });

export interface ISetSelectedExperience {
  type: actionTypes.SET_SELECTED_EXPERIENCE;
  experienceId: ExperienceId;
}

export const setSelectedExperience = (
  experienceId: ExperienceId
): ISetSelectedExperience => ({
  type: actionTypes.SET_SELECTED_EXPERIENCE,
  experienceId,
});

export interface IFetchExperiencesShopOptions {
  type: actionTypes.FETCH_EXPERIENCES_SHOP_OPTIONS;
  request: ExperiencesShopOptionRequest;
}

export const fetchExperiencesShopOptions = (
  request: ExperiencesShopOptionRequest
): IFetchExperiencesShopOptions => ({
  type: actionTypes.FETCH_EXPERIENCES_SHOP_OPTIONS,
  request,
});

export interface ISetExperiencesShopOptions {
  type: actionTypes.SET_EXPERIENCES_SHOP_OPTIONS;
  priceBreakdowns: ExperiencesPriceBreakdown[];
  shopOptionTrackingProperties: TrackingProperties;
}

export const setExperiencesShopOptions = (
  priceBreakdowns: ExperiencesPriceBreakdown[],
  shopOptionTrackingProperties: TrackingProperties
): ISetExperiencesShopOptions => ({
  type: actionTypes.SET_EXPERIENCES_SHOP_OPTIONS,
  priceBreakdowns,
  shopOptionTrackingProperties,
});

export interface ISetExperiencesShopOptionsCallStateFailed {
  type: actionTypes.SET_EXPERIENCES_SHOP_OPTIONS_CALL_FAILED;
}

export const setExperiencesShopOptionsCallStateFailed =
  (): ISetExperiencesShopOptionsCallStateFailed => ({
    type: actionTypes.SET_EXPERIENCES_SHOP_OPTIONS_CALL_FAILED,
  });

export interface IFetchExperiencesShopReviews {
  type: actionTypes.FETCH_EXPERIENCES_SHOP_REVIEWS;
  request: ExperiencesShopReviewsRequest;
}

export const fetchExperiencesShopReviews = (
  request: ExperiencesShopReviewsRequest
): IFetchExperiencesShopReviews => ({
  type: actionTypes.FETCH_EXPERIENCES_SHOP_REVIEWS,
  request,
});

export interface ISetExperiencesShopReviews {
  type: actionTypes.SET_EXPERIENCES_SHOP_REVIEWS;
  response: ExperiencesShopReviewsResponse;
}

export const setExperiencesShopReviews = (
  response: ExperiencesShopReviewsResponse
): ISetExperiencesShopReviews => ({
  type: actionTypes.SET_EXPERIENCES_SHOP_REVIEWS,
  response,
});

export interface ISetExperiencesShopReviewsCallStateFailed {
  type: actionTypes.SET_EXPERIENCES_SHOP_REVIEWS_CALL_STATE_FAILED;
}

export const setExperiencesShopReviewsCallStateFailed =
  (): ISetExperiencesShopReviewsCallStateFailed => ({
    type: actionTypes.SET_EXPERIENCES_SHOP_REVIEWS_CALL_STATE_FAILED,
  });

export interface ISetTravelerCounts {
  type: actionTypes.SET_TRAVELER_COUNTS;
  counts: IPassengerCounts;
}

export const setTravelerCounts = (
  counts: IPassengerCounts
): ISetTravelerCounts => ({
  type: actionTypes.SET_TRAVELER_COUNTS,
  counts,
});

export interface ISetSelectedTime {
  type: actionTypes.SET_SELECTED_TIME;
  selectedTime: string;
}

export const setSelectedTime = (selectedTime: string): ISetSelectedTime => ({
  type: actionTypes.SET_SELECTED_TIME,
  selectedTime,
});

export interface ISetSelectedDate  {
  type: actionTypes.SET_SELECTED_DATE;
  selectedDate: string;
}

export const setSelectedDate = (selectedDate: string): ISetSelectedDate => ({
  type: actionTypes.SET_SELECTED_DATE,
  selectedDate,
});

export interface ISetSelectedBookableItem  {
  type: actionTypes.SET_SELECTED_BOOKABLE_ITEM;
  selectedBookableItem: ExperienceBookableItem | null;
}

export const setSelectedBookableItem = (selectedBookableItem: ExperienceBookableItem | null): ISetSelectedBookableItem => ({
  type: actionTypes.SET_SELECTED_BOOKABLE_ITEM,
  selectedBookableItem,
});

export type ExperiencesShopActions =
  | IFetchExperiencesShop
  | ISetExperiencesShopDetails
  | ISetExperiencesShopDetailsCallStateFailed
  | ISetSelectedExperience
  | IFetchExperiencesShopOptions
  | ISetExperiencesShopOptions
  | ISetExperiencesShopOptionsCallStateFailed
  | IFetchExperiencesShopReviews
  | ISetExperiencesShopReviews
  | ISetExperiencesShopReviewsCallStateFailed
  | ISetTravelerCounts
  | ISetSelectedTime
  | ISetSelectedDate
  | ISetSelectedBookableItem;
